import React from "react";
import {Button, Table} from "react-bootstrap";
import {BsPencil, BsTrash} from "react-icons/bs";
import {toggleBannerActive} from "../../Api/Banners/BannersFetch";

const POSITION_LABELS = {
    after_trainings: 'Dopo gli allenamenti',
    after_games: 'Dopo le gare',
};

const BannersTable = ({banners, onEdit, onDelete, update, setUpdate, setErrors}) => {
    if (!banners || banners.length === 0) {
        return <p className={'text-muted mt-3'}>Nessun banner presente.</p>;
    }

    return (
        <Table responsive hover className={'mt-3'}>
            <thead>
            <tr>
                <th>Immagine</th>
                <th>Titolo</th>
                <th>Posizione</th>
                <th>Link</th>
                <th>Ordine</th>
                <th>Stato</th>
                <th>Inizio</th>
                <th>Fine</th>
                <th>Azioni</th>
            </tr>
            </thead>
            <tbody>
            {banners.map(banner => (
                <tr key={banner.id}>
                    <td>
                        {banner.image_url ? (
                            <img
                                src={banner.image_url}
                                alt={banner.title}
                                style={{height: '50px', maxWidth: '120px', objectFit: 'cover', borderRadius: '4px'}}
                            />
                        ) : (
                            <span className={'text-muted'}>-</span>
                        )}
                    </td>
                    <td className={'align-middle'}>{banner.title}</td>
                    <td className={'align-middle'}>{POSITION_LABELS[banner.position] || banner.position}</td>
                    <td className={'align-middle'}>
                        {banner.link_url ? (
                            <a href={banner.link_url} target={'_blank'} rel={'noreferrer'} className={'text-truncate d-block'} style={{maxWidth: '150px'}}>
                                {banner.link_url}
                            </a>
                        ) : '-'}
                    </td>
                    <td className={'align-middle'}>{banner.sort_order}</td>
                    <td className={'align-middle'}>
                        <div
                            onClick={() => toggleBannerActive({
                                bannerId: banner.id,
                                is_active: banner.is_active,
                                update,
                                setUpdate,
                                setErrors,
                            })}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '7px',
                                cursor: 'pointer',
                                background: banner.is_active ? '#d1fae5' : '#f3f4f6',
                                border: `1.5px solid ${banner.is_active ? '#6ee7b7' : '#d1d5db'}`,
                                borderRadius: '999px',
                                padding: '4px 12px 4px 8px',
                                transition: 'all 0.2s',
                                userSelect: 'none',
                                width: 'fit-content',
                            }}
                        >
                            <span style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: banner.is_active ? '#10b981' : '#9ca3af',
                                display: 'inline-block',
                                flexShrink: 0,
                            }}/>
                            <span style={{
                                fontSize: '13px',
                                fontWeight: 500,
                                color: banner.is_active ? '#065f46' : '#6b7280',
                                whiteSpace: 'nowrap',
                            }}>
                                {banner.is_active ? 'Attivo' : 'Non attivo'}
                            </span>
                        </div>
                    </td>
                    <td className={'align-middle'}>{banner.starts_at ? banner.starts_at.substring(0, 10) : '-'}</td>
                    <td className={'align-middle'}>{banner.ends_at ? banner.ends_at.substring(0, 10) : '-'}</td>
                    <td className={'align-middle'}>
                        <Button
                            size={'sm'}
                            className={'bkg-second border-0 me-2'}
                            onClick={() => onEdit(banner)}
                        >
                            <BsPencil/>
                        </Button>
                        <Button
                            size={'sm'}
                            variant={'danger'}
                            onClick={() => onDelete(banner)}
                        >
                            <BsTrash/>
                        </Button>
                    </td>
                </tr>
            ))}
            </tbody>
        </Table>
    );
};

export default BannersTable;
